import React from "react";
import pdfFileIcon from "@assets/icons/pdf-icon.svg";
import tickGreenCircle from "@assets/icons/tick-green-circle.svg";
import styles from "./PDFUpload.module.css";

function PDFUpload({ fileData }: any) {
  return (
    <div className={styles.fileListItem}>
      <div className={styles.fileImage}>
        <img src={pdfFileIcon} alt="PDF File" />
      </div>
      <div className={styles.fileInfo}>
        <span>{fileData.fileName}</span>
        <span>|</span>
        <span>{fileData.admissionId}</span>
      </div>
      <div>
        {fileData.uploadStatus == "success" && (
          <img
            className={styles.uploadStatusSuccess}
            src={tickGreenCircle}
            alt="Success"
          />
        )}
        {fileData.uploadStatus != "success" && (
          <div className={styles.uploadPending}></div>
        )}
      </div>
    </div>
  );
}

export default PDFUpload;
